<template>
  <div>
    <h3
      class="mt-6 text-mobile-xl font-semibold first-letter:uppercase md:mt-10"
      :class="big ? 'md:text-2xl' : 'md:text-xl'"
    >
      {{ $t('labels.share') }}
    </h3>
    <ul class="flex gap-4 mt-4 md:gap-6 md:mt-6">
      <li>
        <ClientOnly>
          <button
            class="p-3 border border-shade-200 hover:border-shade-300 focus:border-transparent focus:ring-2 ring-primary-400 transition-colors duration-200 ease-in-out"
          >
            <ShareNetwork network="facebook" :url="currentUrl">
              <IconFacebook class="w-6 h-6" />
            </ShareNetwork>
          </button>
        </ClientOnly>
      </li>
      <li>
        <ClientOnly>
          <button
            class="p-3 border border-shade-200 hover:border-shade-300 focus:border-transparent focus:ring-2 ring-primary-400 transition-colors duration-200 ease-in-out"
          >
            <ShareNetwork network="linkedin" :url="currentUrl">
              <IconLinkedin class="w-6 h-6" />
            </ShareNetwork>
          </button>
        </ClientOnly>
      </li>
      <li>
        <ClientOnly>
          <button
            class="p-3 border border-shade-200 hover:border-shade-300 focus:border-transparent focus:ring-2 ring-primary-400 transition-colors duration-200 ease-in-out"
          >
            <ShareNetwork network="twitter" :url="currentUrl">
              <IconTwitter class="w-6 h-6" />
            </ShareNetwork>
          </button>
        </ClientOnly>
      </li>
    </ul>
  </div>
</template>
<script lang="ts" setup>
import IconFacebook from '~/assets/icon/social/Facebook.svg'
import IconLinkedin from '~/assets/icon/social/Linkedin.svg'
import IconTwitter from '~/assets/icon/social/Twitter.svg'

const currentUrl = ref('')

onMounted(() => {
  currentUrl.value = window.location.href
})

defineProps({
  big: {
    type: Boolean,
    default: false,
  },
})
</script>
